// Styles
import "../sass/main.scss";

// Images.
import "../img/picto-1.svg";
import "../img/picto-2.svg";
import "../img/picto-3.svg";
import "../img/cityrent_logo.svg";
import "../img/workpoint_logo.svg";
import "../img/shape.svg";
import "../img/logo-citypartner.svg";
import "../img/favicon.ico";
import "../img/favicon.png";

import "parsleyjs";
import "magnific-popup";
import barba from "@barba/core";
import Parallax from "parallax-js";
import Swiper from "swiper/bundle";
import gsap from "gsap";
import LocomotiveScroll from "locomotive-scroll";

(function ($) {
  "use strict";

  function debug(report) {
    // console.log(report);
  }

  var scroll;
  var introAnimated = false;

  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  var loadingScreen = document.querySelector(".loading-screen");
  var mainNavigation = document.querySelector(".header-vertical-navigation");
  var socialNavigation = document.querySelector(".vertical-widget-holder");
  var mobileOpener = jQuery(".mobile-header-opener");
  var mobileNavigation = jQuery(".mobile-header-navigation");
  var vpwidth;

  barba.hooks.before(() => {
    document.querySelector("html").classList.add("is-transitioning");
  });
  barba.hooks.after(() => {
    document.querySelector("html").classList.remove("is-transitioning");
  });

  var spinning;

  barba.init({
    sync: true,
    debug: false,
    timeout: 5000, // default is 2000ms
    transitions: [
      {
        name: "custom-transition",
        async once({ next }) {
          //next.namespace
          handleCustomCursor();
          debug("Barba Once");
          await contentAnimation2(next.container);
          set_current_menu_item(next);

          /*
          spinning = gsap.to(".header-logo #loader", {
            rotation: "360",
            repeat: -1,
            duration: 0.6,
            transformOrigin: "center center",
            paused: true,
            ease: "power1.inOut",
          });
          */
        },
        async leave(data) {
          var toggle = gsap.timeline();
          toggle.add(function () {
            //spinning.paused(!spinning.paused());
          });
          toggle.to(".header-logo #gilet", { opacity: 0, duration: 0.3 });
          toggle.to(".header-logo #arrows", { opacity: 1, duration: 0.3 });

          await pageTransitionIn2(data.current.container);
          data.current.container.remove();
        },
        async enter({ next }) {
          await contentAnimation2(next.container);

          // await pageTransitionOut2(next.container);

          var toggle = gsap.timeline({
            onComplete: function () {
              spinning.paused(!spinning.paused());
            },
          });
          toggle.to(".header-logo #arrows", { opacity: 0, duration: 0.3 });
          toggle.to(".header-logo #gilet", { opacity: 1, duration: 0.3 });
          set_current_menu_item(next);
        },
      },
    ],
  });

  /**
   * Magnific Popup
   */
  function MPInit() {
    $.extend(true, $.magnificPopup.defaults, {
      tClose: "Fermer (Esc)", // Alt text on close button
      tLoading: "Chargement...", // Text that is displayed during loading. Can contain %curr% and %total% keys
      gallery: {
        tPrev: "Précédent (Flèche de gauche)", // Alt text on left arrow
        tNext: "Suivant (Flèche de droite)", // Alt text on right arrow
        tCounter: "%curr% de %total%", // Markup for "1 of 7" counter
      },
      image: {
        tError: '<a href="%url%">The image</a> ne peut être chargée.', // Error message when image could not be loaded
      },
      ajax: {
        tError: '<a href="%url%">The content</a> ne peut être chargé.', // Error message when ajax request failed
      },
    });

    $(".woocommerce-product-gallery").magnificPopup({
      delegate: "a",
      type: "image",
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: "mfp-with-zoom mfp-img-mobile",
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.el.attr("title");
        },
      },
      gallery: {
        enabled: true,
      },
      zoom: {
        enabled: false,
        duration: 300, // don't foget to change the duration also in CSS
        opener: function (element) {
          return element.find("img");
        },
      },
    });
  }

  function Init_Swiper() {
    debug("InitSwiper");

    var hero = new Swiper(".swiper-hero", {
      //init: false,
      effect: "fade",
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      on: {
        init: function () {
          debug("swiper initialized");
        },
      },
    });

    var place = new Swiper(".swiper-place", {
      //init: false,
      effect: "fade",
      autoplay: {
        delay: 4500,
        disableOnInteraction: true,
      },
      on: {
        init: function () {
          debug("swiper initialized");
        },
      },
    });

    var service = new Swiper(".swiper-service", {
      //init: false,
      effect: "fade",
      autoplay: {
        delay: 4500,
        disableOnInteraction: true,
      },
      on: {
        init: function () {
          debug("swiper initialized");
        },
      },
    });

    var works = new Swiper(".swiper-works", {
      //init: false,
      //effect: "fade",
      slidesPerView: "auto",
      spaceBetween: 0,
      grabCursor: true,
      autoHeight: true,
      //centeredSlides: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      breakpoints: {
        576: {
          freeMode: false,
          spaceBetween: 30,
          autoHeight: false,
          freeMode: true,
        },
      },
      on: {
        init: function () {
          debug("swiper initialized");
        },
      },
    });

    var works = new Swiper(".swiper-partners", {
      //init: false,
      //effect: "fade",
      slidesPerView: 3,
      spaceBetween: 10,
      grabCursor: true,
      autoHeight: false,
      //centeredSlides: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      breakpoints: {
        576: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 6,
          spaceBetween: 30,
        },
      },
      on: {
        init: function () {
          debug("swiper initialized");
        },
      },
    });
  }

  function smooth(container) {
    debug("smooth");
    var sscroll = container.querySelector("[data-scroll-container]");
    scroll = new LocomotiveScroll({
      el: sscroll,
      smooth: true,
      repeat: true,
    });
  }

  function headerParallax() {
    debug("headerParallax");
    var scene = document.getElementById("scene");
    if (scene !== null) {
      var parallaxInstance = new Parallax(scene);
    }
  }

  function set_current_menu_item(next) {
    // console.log(next);

    var menu = document.querySelector(".menu");
    var listItem = menu.querySelector(".menu-item");
    var listItemActive = menu.querySelector(".is-active");
    var nextItem = menu.querySelector(`a[href="${next.url.href}"]`);

    //debug("set_current_menu_item", next);

    // Remove all actives elements
    var activeItems = menu.querySelector(".item-active");
    if (activeItems !== null) {
      activeItems.classList.remove("item-active");
    }
    if (listItemActive !== null) {
      listItemActive.classList.remove("is-active");
    }

    // Add active element
    if (nextItem !== null) {
      nextItem.classList.add("item-active");

      var listItemWithChildren = nextItem.closest(".menu-item-has-children");
      if (listItemWithChildren !== null) {
        debug("listItemWithChildren", listItemWithChildren);
        listItemWithChildren.classList.add("is-active");
      }
    }

    // Create a clone of element with id ddl_1:
    var elToClone = next.container.querySelector("#footer_language_nav");
    if (elToClone !== null) {
      document.querySelector("#page-header-lang").innerHTML = "";
      document.querySelector("#mobile-page-header-lang").innerHTML = "";
      let clone = elToClone.cloneNode(true);
      let mobileclone = elToClone.cloneNode(true);
      // Change the id attribute of the newly created element:
      clone.setAttribute("id", "main_language_nav");
      // Append the newly created element on element p
      document.querySelector("#page-header-lang").appendChild(clone);
      document
        .querySelector("#mobile-page-header-lang")
        .appendChild(mobileclone);
    }
  }

  function get_WiewportWidth() {
    debug("WPW");
    var vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    return vw;
  }

  function pageTransitionIn2(container) {
    var transition;
    if (get_WiewportWidth() < 1200) {
      mobileNavigation.is(":visible")
        ? (mobileNavigation.slideUp(450),
          mobileOpener.removeClass("qodef--opened"))
        : null;
    }
    transition = gsap
      .timeline()
      // .to(mainNavigation, {
      //   duration: 0.3,
      //   translateX: 0,
      //   opacity: 0.5,
      //   ease: "power1.inOut",
      // })
      // .to(loadingScreen, {
      //   duration: 0.2,
      //   opacity: 1,
      //   width: "100%",
      //   ease: "power1.inOut",
      // })
      .to(container, {
        duration: 0.2,
        // translateX: -10,
        opacity: 0,
        // ease: "power1.inOut",
      });
    return transition;
  }

  function contentAnimation2(container) {
    //debug(container);
    headerParallax();
    MPInit();
    convertSVG();
    Init_Swiper();

    return gsap
      .timeline()
      .to(container, {
        duration: 0.2,
        // translateX: 0,
        opacity: 1,
        // ease: "power1.inOut",
      })
      .call(function () {
        debug("Benoui ok maintenant on init");
        smooth(container);
        InitFuncFormContact();
        scroll.scrollTo(0);
        //headerParallax();
      });
    //.from(mainNavigation, { duration: .5, translateY: -10, opacity: 0})
  }

  function delay(n) {
    n = n || 2000;
    return new Promise((done) => {
      setTimeout(() => {
        done();
      }, n);
    });
  }

  function convertSVG() {
    //debug("convertSVG");
    jQuery("img.svg").each(function () {
      var $img = jQuery(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");

      //debug(imgURL);
      jQuery.get(imgURL, function (data) {
        var $svg = jQuery(data).find("svg");

        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }
        $svg = $svg.removeAttr("xmlns:a");
        $svg = $svg.removeAttr("width");
        $svg = $svg.removeAttr("height");

        $img.replaceWith($svg);
      });
    });
  }

  function InitFuncFormContact() {
    debug("InitFuncFormContact");

    // Contact

    $("#contact-form").parsley();
    $("#contact-form").on("submit", function (e) {
      e.preventDefault();
      var t = $(this),
        o = t.find("#valid-form");
      t.parsley().validate(),
        (o.disabled = !0),
        (o.innerText = "Envoi..."),
        t.parsley().isValid() &&
          $.ajax({
            url: ajaxurl,
            data: $(this).serialize(),
            type: "POST",
            success: function (e) {
              debug(e),
                $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-success")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".messages").fadeIn();
                }, 300);
            },
            error: function (e) {
              debug(e);
              $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-danger")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".sub_error").css("opacity", "1");
                }, 300);
            },
          });
    });

    // jobs
    $("#job-form").parsley();
    $("#curiculum").on("change", function () {
      //get the file name
      var fileName = $(this).val();
      //replace the "Choose a file" label
      $(this).next(".custom-file-label").html(fileName);
    });

    $("#job-form").on("submit", function (e) {
      e.preventDefault();
      var t = $(this),
        o = document.getElementById("valid-form");

      var file_data = $("#curiculum").prop("files")[0];

      var $form = jQuery(this);
      var formdata = window.FormData ? new FormData($form[0]) : null;
      formdata.append("file", file_data);
      var data = formdata !== null ? formdata : $form.serialize();

      debug($form.serialize());

      var formData = new FormData($(this)[0]);
      formData.append("file", file_data);
      for (var pair of formData.entries()) {
        debug(pair[0] + ", " + pair[1]);
      }

      t.parsley().validate(),
        (o.disabled = !0),
        (o.innerText = "Envoi..."),
        t.parsley().isValid() &&
          $.ajax({
            url: ajaxurl,
            cache: false,
            contentType: false,
            processData: false,
            //data: $(this).serialize(),
            data: formData,
            type: "POST",
            success: function (e) {
              debug(e),
                $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-success")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".messages").fadeIn();
                }, 300);
            },
            error: function (e) {
              $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-danger")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".sub_error").css("opacity", "1");
                }, 300);
            },
          });
    });

    var formDataSuppoerted = function () {
      return !!("FormData" in window);
    };

    window.Parsley.addValidator("filemaxmegabytes", {
      requirementType: "string",
      validateString: function (value, requirement, parsleyInstance) {
        if (!formDataSuppoerted()) {
          return true;
        }

        var file = parsleyInstance.$element[0].files;
        var maxBytes = requirement * 1048576;

        if (file.length == 0) {
          return true;
        }

        return file.length === 1 && file[0].size <= maxBytes;
      },
      messages: {
        en: "Fichier trop volumineux. Maximum 2Mo.",
      },
    }).addValidator("filemimetypes", {
      requirementType: "string",
      validateString: function (value, requirement, parsleyInstance) {
        if (!formDataSuppoerted()) {
          return true;
        }

        var file = parsleyInstance.$element[0].files;

        if (file.length == 0) {
          return true;
        }

        var allowedMimeTypes = requirement.replace(/\s/g, "").split(",");
        return allowedMimeTypes.indexOf(file[0].type) !== -1;
      },
      messages: {
        fr: "Ce type de fichier n'est pas valide. Seulement les fichiers .pdf, .doc et .docx sont autorisés.",
      },
    });
  }

  if (isMobile.any()) {
    jQuery("body").removeClass("custom-cursor");
  }

  // Custom cursor
  function handleCustomCursor() {
    if (jQuery("body").hasClass("custom-cursor")) {
      var cursorInnerEl = document.querySelector(".circle-cursor--inner");
      var cursorOuterEl = document.querySelector(".circle-cursor--outer");
      var lastY,
        lastX = 0;
      var magneticFlag = false;

      // move
      window.onmousemove = function (event) {
        if (!magneticFlag) {
          cursorOuterEl.style.transform =
            "translate(" + event.clientX + "px, " + event.clientY + "px" + ")";

          /*Old code*/
          // cursorOuterEl.style.top = event.clientY + 'px';
          // cursorOuterEl.style.left = event.clientX + 'px';
        }
        cursorInnerEl.style.transform =
          "translate(" + event.clientX + "px, " + event.clientY + "px" + ")";

        /*Old code*/
        // cursorInnerEl.style.top = event.clientY + 'px';
        // cursorInnerEl.style.left = event.clientX + 'px';
        lastY = event.clientY;
        lastX = event.clientX;
      };

      // links hover
      jQuery("body").on("mouseenter", "a, .cursor-as-pointer", function () {
        cursorInnerEl.classList.add("cursor-link-hover");
        cursorOuterEl.classList.add("cursor-link-hover");
      });
      jQuery("body").on("mouseleave", "a, .cursor-as-pointer", function () {
        if (
          jQuery(this).is("a") &&
          jQuery(this).closest(".cursor-as-pointer").length
        ) {
          return;
        }
        cursorInnerEl.classList.remove("cursor-link-hover");
        cursorOuterEl.classList.remove("cursor-link-hover");
      });

      // additional hover cursor class
      jQuery("body").on("mouseenter", "[data-cursor-class]", function () {
        var cursorClass = jQuery(this).attr("data-cursor-class");
        // cursorInnerEl.classList.add(cursorClass);
        // cursorOuterEl.classList.add(cursorClass);

        if (cursorClass.indexOf("dark-color") != -1) {
          cursorInnerEl.classList.add("dark-color");
          cursorOuterEl.classList.add("dark-color");
        }

        if (cursorClass.indexOf("cursor-link") != -1) {
          cursorInnerEl.classList.add("cursor-link");
          cursorOuterEl.classList.add("cursor-link");
        }
      });
      jQuery("body").on("mouseleave", "[data-cursor-class]", function () {
        var cursorClass = jQuery(this).attr("data-cursor-class");
        if (cursorClass.indexOf("dark-color") != -1) {
          cursorInnerEl.classList.remove("dark-color");
          cursorOuterEl.classList.remove("dark-color");
        }

        if (cursorClass.indexOf("cursor-link") != -1) {
          cursorInnerEl.classList.remove("cursor-link");
          cursorOuterEl.classList.remove("cursor-link");
        }
      });

      // magnet elements
      jQuery("body").on(
        "mouseenter",
        ".cursor-magnet, .btn-round",
        function () {
          var $elem = jQuery(this);
          var scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

          cursorOuterEl.style.transition = "all .2s ease-out";
          cursorOuterEl.style.transform =
            "translate(" +
            $elem.offset().left +
            "px, " +
            ($elem.offset().top - scrollTop) +
            "px" +
            ")";

          /*Old code*/
          // cursorOuterEl.style.top = ($elem.offset().top - scrollTop) + 'px';
          // cursorOuterEl.style.left = $elem.offset().left + 'px';
          cursorOuterEl.style.width = $elem.width() + "px";
          cursorOuterEl.style.height = $elem.height() + "px";
          cursorOuterEl.style.marginLeft = 0;
          cursorOuterEl.style.marginTop = 0;

          magneticFlag = true;
        }
      );

      jQuery("body").on(
        "mouseleave",
        ".cursor-magnet, .btn-round",
        ohioRemoveMagneticFromCursor
      );

      function ohioRemoveMagneticFromCursor() {
        cursorOuterEl.style.transition = null;
        cursorOuterEl.style.width = null;
        cursorOuterEl.style.height = null;
        cursorOuterEl.style.marginLeft = null;
        cursorOuterEl.style.marginTop = null;

        /*Old code*/
        // cursorOuterEl.style.top = lastY + 'px';
        // cursorOuterEl.style.left = lastX + 'px';

        magneticFlag = false;
      }

      // Custom leave trigger
      jQuery("body").on("ohio:cursor_mouseleave", function () {
        ohioRemoveMagneticFromCursor();

        cursorOuterEl.style.transform = cursorInnerEl.style.transform;

        cursorInnerEl.classList.remove("cursor-link-hover");
        cursorOuterEl.classList.remove("cursor-link-hover");
      });

      //iframe fix
      jQuery("body").on("mouseenter", "iframe", function () {
        cursorOuterEl.style.visibility = "hidden";
        cursorInnerEl.style.visibility = "hidden";
      });
      jQuery("body").on("mouseleave", "iframe", function () {
        cursorOuterEl.style.visibility = "visible";
        cursorInnerEl.style.visibility = "visible";
      });

      cursorInnerEl.style.visibility = "visible";
      cursorOuterEl.style.visibility = "visible";
    }
  }

  if (mobileOpener.length) {
    jQuery("body").on("tap click", ".mobile-header-opener", function (e) {
      e.preventDefault();
      mobileNavigation.is(":visible")
        ? (mobileNavigation.slideUp(450),
          mobileOpener.removeClass("qodef--opened"))
        : (mobileNavigation.slideDown({
            start: function () {
              $(this).css({
                display: "flex",
              });
            },
          }),
          mobileOpener.addClass("qodef--opened"));
    });
  }
})(jQuery);

Parsley.addMessages("fr", {
  defaultMessage: "Cette valeur semble non valide.",
  type: {
    email: "Cette valeur n'est pas une adresse email valide.",
    url: "Cette valeur n'est pas une URL valide.",
    number: "Cette valeur doit être un nombre.",
    integer: "Cette valeur doit être un entier.",
    digits: "Cette valeur doit être numérique.",
    alphanum: "Cette valeur doit être alphanumérique.",
  },
  notblank: "Cette valeur ne peut pas être vide.",
  required: "Ce champ est requis.",
  pattern: "Cette valeur semble non valide.",
  min: "Cette valeur ne doit pas être inférieure Ã  %s.",
  max: "Cette valeur ne doit pas excéder %s.",
  range: "Cette valeur doit être comprise entre %s et %s.",
  minlength:
    "Cette chaîne est trop courte. Elle doit avoir au minimum %s caractères.",
  maxlength:
    "Cette chaîne est trop longue. Elle doit avoir au maximum %s caractères.",
  length: "Cette valeur doit contenir entre %s et %s caractères.",
  mincheck: "Vous devez sélectionner au moins %s choix.",
  maxcheck: "Vous devez sélectionner %s choix maximum.",
  check: "Vous devez sélectionner entre %s et %s choix.",
  equalto: "Cette valeur devrait être identique.",
});

Parsley.setLocale("fr");
